import { useQuery } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { api } from '../api/endpoints';
import { useProject } from '../projects/context';
import { PhoneContext } from './phoneContext';
import { useBrowserPhone } from './useBrowserPhone';

// PhoneProvider hält das Browser-Telefon für die ganze Sitzung bereit – nicht nur in der Akquise, damit
// Rückrufe von Kunden überall klingeln (Telefonisten mit Browser-Telefonie).
export function PhoneProvider({ children }: { children: ReactNode }) {
  const { project, can } = useProject();
  const agent = useQuery({ queryKey: ['me', 'telephony'], queryFn: ({ signal }) => api.telephonyAgent(signal), enabled: can('call.start') });
  const browserMode = agent.data?.mode === 'BROWSER';
  const phone = useBrowserPhone(project.id, browserMode);
  return <PhoneContext value={{ ...phone, browserMode }}>{children}</PhoneContext>;
}
